import styled from 'styled-components';

export const LabelWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Asterisk = styled.span`
  color: #d32f2f;
  margin-left: 4px;
  font-weight: bold;
`;
